import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'gold' | 'navy';
};
export const CHECKOUT_URL = 'https://the-academic-edge.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'gold'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[18px]' : 'min-h-[58px] px-6 py-3.5 text-base';
  const skin = variant === 'navy' ? 'bg-navy text-white shadow-[0_10px_40px_-8px_rgba(27,63,160,0.8)] ring-1 ring-gold/40 hover:bg-navy-deep hover:shadow-[0_16px_50px_-8px_rgba(27,63,160,0.95)] focus-visible:ring-gold' : 'bg-gold text-ink shadow-[0_10px_40px_-8px_rgba(212,175,55,0.7)] ring-1 ring-gold-soft/70 hover:bg-gold-soft hover:shadow-[0_16px_50px_-8px_rgba(212,175,55,0.9)] focus-visible:ring-white';
  return <a href={href} className={cn('group inline-flex w-full max-w-[340px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} data-id="element-51" data-mp="199elkjbamkiu">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-52" data-mp="1s7qxudxi4ain" />
    </a>;
}